import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import type SessionService from 'bcl/services/session';
import Modal from 'bcl/components/modal';
import { on } from '@ember/modifier';
import { fn } from '@ember/helper';
import filterSort from 'bcl/helpers/filter-sort';
import FeedbackWarning from 'bcl/components/feedback/warning';

interface ModalNewOrderSignature {
  // The arguments accepted by the component
  Args: {
    toggle: () => void;
    shown: boolean;
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: null;
}

export default class ModalNewOrderComponent extends Component<ModalNewOrderSignature> {
  @service store;
  @service declare router: RouterService;
  @service declare session: SessionService;

  get hasStandardOrder() {
    const suppliers = this.store.peekAll('supplier');
    const supWithStandard = suppliers
      .filter((supplier) =>
        supplier.supplierItems.some((item) => item.standard_order)
      )
      .sort((a, b) => a.name.localeCompare(b.name));
    return supWithStandard;
  }
  get allSuppliers() {
    return this.store
      .peekAll('supplier')
      .filter((s) => s.additional != 'special');
  }
  get allLocations() {
    return this.store.peekAll('location');
  }
  @action createNewOrder(to: string, supl_id?: any) {
    this.args.toggle();
    this.session.orderKind = to;
    this.session.orderSuplID = supl_id;

    this.router.transitionTo('auth.orders.new');
  }
  get hasCreatedOrders() {
    const allOrders = this.store.peekAll('order');
    const createdOrders = allOrders.filter((o) => o.status == 'created');
    return createdOrders.length > 0;
  }

  <template>
    {{#if @shown}}
      {{!-- {{#if true}} --}}
      <Modal @close={{@toggle}} @size="big">
        <div class="block">
          {{#if this.hasCreatedOrders}}
            <FeedbackWarning @header="Bestehende Bestellung" class="mb-4">
              <p>Es besteht eine Bestellung, die noch nicht als bestellt
                markiert ist. Dadurch kann die Berechnung für den Bestand falsch
                sein.</p>
            </FeedbackWarning>
          {{/if}}

          <h2 class="text-xl font-bold">Standardbestellung</h2>
          {{#each this.hasStandardOrder as |supl|}}

            <button
              {{on "click" (fn this.createNewOrder "standard" supl.id)}}
              type="button"
              class="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >{{supl.name}}</button>

          {{else}}
            <h3>Es existieren keine Standardbestellung-Artikel.</h3>
          {{/each}}

        </div>
        <div class="block">
          <h2 class="text-xl font-bold mt-4">Andere Bestellungen</h2>

          <button
            {{on "click" (fn this.createNewOrder "frei")}}
            type="button"
            class="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >freie Bestellung</button>
        </div>
        <div class="block">
          <h2 class="text-xl font-bold mt-4">Bestellungen nach Bestand</h2>
          {{#each (filterSort this.allSuppliers "active" "name") as |supplier|}}
            <button
              {{on "click" (fn this.createNewOrder "bestand" supplier.id)}}
              type="button"
              class="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            > {{supplier.name}} </button>

          {{/each}}

        </div>
      </Modal>
    {{/if}}
  </template>
}
